<template>
  <div>
    <div v-for="(item, i) in releases" v-bind:key="i">
      <div class="box">
        <div>
          <div class="version">
            <span>{{ item.version }}</span>
          </div>
          <div class="date">
            <!-- {{ getFormattedDate(item.date) }} -->
          </div>
        </div>
        <div style="margin-left: 60px">
          <div
            v-for="(change, index) in item.changes"
            :key="index"
            class="box-change"
          >
            <div :class="getClass(change.type)">
              {{ getTypeText(change.type) }}
            </div>
            <div class="description">{{ change.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from "../../ajax.js";
import moment from "moment";
export default {
  name: "ChangeLog",
  data: () => {
    return {
      releases: [],
    };
  },

  mounted: function () {
    this.getChangeLog();
  },
  methods: {
    getTypeText(type) {
      switch (type) {
        case "Feature":
          return "Novità";
        default:
          return type;
      }
    },
    getClass(type) {
      return type == "BugFix" ? "bugfix type" : "feature type";
    },
    getFormattedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getChangeLog: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/communication/changelog/", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response.data.data != null) {
            self.releases = response.data.data.map((x) => {
              return { ...x, date: new Date(x.date) };
            });
            self.setCurrentReview(response.data.data[0].version);
          }
        })
        .catch(function (error) {
          let auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    setCurrentReview: function (val) {
      this.$emit("currentRelease", val);
    },
  },
};
</script>

<style scoped>
.feature {
  background: green;
}
.bugfix {
  background: red;
}
.box-change {
  padding: 5px;
}
.date {
  padding: 10px;
  font-weight: bold;
  font-size: 20px;
}
.box {
  border: 1px solid grey;
  border-radius: 5px;
  padding: 15px;
  margin: 5px;
  margin-bottom: 20px;
}
.version {
  background: orange;
  color: white;
  padding: 8px;
  border-radius: 5px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 60px;
  
  margin-right: 20px;
}
.type {
  color: white;
  padding: 5px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: bold;
  width: 80px;
  float: left;
  text-align: center;
  margin-right: 10px;
}
.description {
  padding: 5px;
  margin-left: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/ChangeLog.vue